import React from 'react';
import RestEdit from 'containers/rest/Edit';
import Form from '../components/Form';
import { omit } from 'lodash';
import { getDataDetail } from 'utils/tools';
import { useSelector } from '@redux';
import { DynamicObjectType } from 'core/types/common';
// import { omit } from 'lodash';
// import { getDataDetail } from 'utils/tools';

const breadcrumbs = [
  {
    title: 'common.page.transferOrders',
    href: '/transfer-orders',
  },
  {
    title: 'common.page.edit',
  },
];

const Edit = () => {
  const data = useSelector<DynamicObjectType>(
    (state) => state.transferOrders.currentData,
  );
  return (
    <RestEdit
      model="transferOrders"
      breadcrumbs={breadcrumbs}
      formatOnSubmit={(values) => {
        return {
          ...omit(values, ['orderSelected', 'variantsApplied']),
          items: values.variantsApplied.map((item) => ({
            variantSku: item?.variantSku,
            variantName:
              item?.variantName || getDataDetail(item?.product)?.name,
            quantity: item?.quantityEdited,
          })),
          status:
            data?.status === 'REJECTED'
              ? 'AWAITING_CONFIRMATION'
              : data?.status,
        };
      }}
      // customUrlBack="transfer-orders"
      handleDataConvert={(record) => {
        return {
          orderId: record?.orderId,
          orderSelected: [record?.order],
          variantsApplied: record?.items?.map((item) => ({
            ...item,
            quantityEdited: item?.quantityEdited || item?.quantity,
          })),
          images: record?.images,
          description: record?.description,
          fromWarehouseId: record?.fromWarehouseId,
          toWarehouseId: record?.toWarehouseId,
        };
      }}
      apiOptions={{
        isShowSuccessNoti: true,
      }}
      saveButtonLabel="Confirm"
      isOpenModal={data?.status === 'REJECTED'}
      titleModal="common.modal.confirmUpdate"
      descriptionModal="transferOrders.confirmUpdatingDescription"
      customPathAfterSubmit="transfer-orders?status=AWAITING_CONFIRMATION"
    >
      <Form isEdit />
    </RestEdit>
  );
};

export default Edit;
